import axios from "axios";
import { EventBus } from "@/event-bus";
import { RequestTools } from "../services/RequestTools";

export var requestTools = {

    components: {
        EventBus
    },

    created() {
        this.requestTools = new RequestTools();
    },

    methods: {
        async requestGet(url) {
            return await this.requestTools.requestGet(url);
        }
    }
};